<template>
  <el-card shadow="never">
    <div slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item v-if="$root.state.facility" :to="{ name: 'Facility Config' }">{{String($root.state.facilityData.code).toUpperCase()}} Config</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ name: 'Config' }">Config</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <OrgConfig v-if="ready" :org="org" :facility="facility" @reload="getOrg">
    </OrgConfig>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ORG_API } from '../env';
import OrgConfig from './OrgConfig.vue';

export default {
  name: 'OrgPage',
  components: { OrgConfig },
  props: { facility: { type: String, default: null } },
  data() {
    return {
      org: { title: '' },
      ready: false,
    };
  },
  async mounted() {
    await this.getOrg();
    this.ready = true;
  },
  methods: {
    async getOrg() {
      const org = await axios.get(`${ORG_API}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.org = org.data;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrgPage.vue